/**
 * 缓存说明:
 */
import vm from '@/cache/storeTools.js'
import deviceCollectionConfigApi from '@/components/api/deviceCollectionConfigApi.js'

var basestate = {
	deviceIdToConfig:{
		//no_parentarea:config对象
	}
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getConfigByDeviceId(state,getters){
			return (no,parentarea)=>{
				return vm.getBeanById(store,state.deviceIdToConfig,"getConfigByDeviceId",{})(no+"_"+parentarea)
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getConfigByDeviceId(state,id){
			var ids = id.split("_")
			deviceCollectionConfigApi.getDeviceCollectionConfig(ids[0],ids[1],respon=>{
				vm.Vue.set(state.deviceIdToConfig,id,respon)
			})
		}
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */